import Prism from 'prismjs/prism.js';
Prism.plugins.autoloader.languages_path = craft.env.assetsSiteUrl + '/assets/js/common/prismjs/components/';
import PrismAutoloader from 'prismjs/plugins/autoloader/prism-autoloader.min.js';
import PhotoGallery from "../../../components/base/photo-gallery";
import ModalForm from "../../../components/base/forms/modal-form";
import B2bCourseRegistrationFieldGroup
	from "./b2b-course-registration-field-group";
import ItgenContractAcceptForm from "./itgen-contract-accept-form";
import B2bDocsModal from "./b2b-docs-modal";

export default class PageModule {
	constructor() {
		/* B2B Page forms */
		if (craft.page.isB2BPage) {
			this.initB2BForms();
			this.initB2BCourseRegistrationForm();
			this.initB2BDocs();
		} else if (craft.page.isItGenerationContractPage) {
			this.initItgenAcceptForm();
		} else {
			this.initPhotoGallery();
		}
	}

	initB2BForms() {
		const types = ['duplicate', 'reconciliation', 'service', 'other'];

		types.forEach((type) => {
			const $trigger = document.querySelector(`[data-modal-trigger="b2b-${type}"]`);
			if (!$trigger) return;

			const data = { type };

			if (type === 'reconciliation') {
				data.type = 'ract';
			} else if (type === 'service') {
				data.type = 'sact';
			}

			const form = new ModalForm({
				formId: `b2b-${type}`,
				uri: '/1.0/b2b',
				data,
				$modalTriggers: [$trigger],
				hash: type
			});
		});
	}

	initB2BCourseRegistrationForm() {
		const $trigger = document.querySelector(`[data-modal-trigger="b2b-course-registration"]`);

		if (!$trigger) return;

		new ModalForm({
			formId: `b2b-course-registration`,
			uri: '/1.0/b2b/course-registration',
			$modalTriggers: [$trigger],
			hash: 'course-registration',
			fieldGroups: [
				{
					fields: ['exchangeService', 'mailingCity', 'mailingAddress', 'mailingPhone', 'mailingName'],
					Controller: B2bCourseRegistrationFieldGroup
				}
			],
		});
	}

	initB2BDocs() {
		new B2bDocsModal();
	}

	initItgenAcceptForm() {
		new ItgenContractAcceptForm();
	}

	initPhotoGallery() {
		const photoGallery = new PhotoGallery();
	}
}
